import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import { Check, Alert, Close } from 'icon'

const Message = (props) => {
  const { message } = props.message.toJS()

  const getIcon = (typ) => {
    switch (typ) {
      case 'success':
        return <Check />
      case 'error':
        return <Alert />
      default:
        return undefined
    }
  }

  const onClose = () => {
    props.message.createMessage()
  }

  const css = message ? message.type : 'none'
  const text = message ? message.message : ''
  return (
    <PageView className={css}>
      <Msg>
        {getIcon(css)}
        {text}
        <span onClick={onClose}>
          <Close />
        </span>
      </Msg>
    </PageView>
  )
}

const PageView = styled.div`
  width: 100%;
  position: fixed;
  top: 25px;
  z-index: 2000;

  &.none {
    display: none;
  }
`

const Msg = styled.div`
  font-size: 16px;
  text-align: center;
  height: 62px;
  width: 380px;
  padding: 0px 12px;

  background-color: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
`

export default inject('message')(observer(Message))
